import { applicationStore } from '..'

export const getApiHint = () => {
  return {
    key: 'X-SC-LB-Hint',
    value: applicationStore.getState().getApiHint()
  }
}

export const isReportLog = () => {
  return applicationStore.getState().getLogReport()
}

export const isEnableCipher = () => {
  return applicationStore.getState().getCipherEnabled()
}

export const getCipherConfig = () => {
  return applicationStore.getState().getCipherConfig()
}
